import React, { useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

const FireworksDisplay = ({ isActive }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (isActive && canvasRef.current) {
            const myCanvas = canvasRef.current;
            const confettiInstance = confetti.create(myCanvas, { resize: true });

            confettiInstance({
                particleCount: 100,
                spread: 160,
                origin: { y: 0.6 }
            });
        }
    }, [isActive]);

    return (
        <canvas
            ref={canvasRef}
            className="fireworks-canvas"
        />
    );
};

export default FireworksDisplay;
